import request from "@/utils/request";

// 列表(主数据列表)
export function loadExpenseSubjectListDataApi(data) {
  return request({
    url: "web/expenseSubject/listData",
    method: "post",
    data
  });
}
// 导出
export function loadExpenseSubjectExportDataApi(data) {
  return request({
    url: "web/expenseSubject/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateExpenseSubjectApi(data) {
  return request({
    url: "web/expenseSubject/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initExpenseSubjectApi(data) {
  return request({
    url: "web/expenseSubject/init",
    method: "post",
    data
  });
}

// 获取下拉列表
export function getExpenseSubjectListApi(data) {
  return request({
      url: "web/expenseSubject/listSelectData",
      method: "post",
      data
  });
}

// 获取下拉树列表
export function getExpenseSubjectTreeApi(data) {
  return request({
      url: "web/expenseSubject/findTreeData",
      method: "post",
      data
  });
}

// 获取级联下拉列表
export function getExpenseSubjectMapTreeApi(data) {
  return request({
      url: "web/expenseSubject/listSelectTreeMapData",
      method: "post",
      data
  });
}